import { useEffect } from 'react';
import Footer from './Footer.jsx';
import Header from './Header.jsx';
import { seoForPath } from '../seo.js';

const darkHeaderPaths = new Set(['/our-story', '/project-cambodia', '/contact']);

export default function Layout({ path, children }) {
  useEffect(() => {
    document.title = seoForPath(path).title;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [path]);

  return (
    <>
      <Header path={path} darkAtTop={darkHeaderPaths.has(path)} />
      <main id="main">{children}</main>
      <Footer />
    </>
  );
}
